import { render } from "./ClassStatsModal.vue?vue&type=template&id=bfe3d59e&scoped=true"
import script from "./ClassStatsModal.vue?vue&type=script&lang=js"
export * from "./ClassStatsModal.vue?vue&type=script&lang=js"

import "./ClassStatsModal.vue?vue&type=style&index=0&id=bfe3d59e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfe3d59e"]])

export default __exports__